<div aria-labelledby="properties-tab" class="tab-pane active container-fluid" role="tabpanel">
	<div class="d-flex">
		<jhi-column-filter [eventName]="COLUMN_FILTER_EVENT_NAME" [filters]="filters" [request]="request"
						   class="flex-sm-grow-1"></jhi-column-filter>
	</div>
	<div class="row pt-3 g-2 g-lg-3">
		<div class="col-12 col-xl-auto d-flex flex-wrap align-items-center gap-2">
			<label class="mb-0 text-nowrap" jhiTranslate="global.records.per.page">Records per page:</label>
			<div class="flex-shrink-0">
				<select [(ngModel)]="itemsPerPage" class="form-select ms-2" name="itemsPerPage" [disabled]="isLoading" (change)="resetTable();">
					<option value="20">20</option>
					<option value="50">50</option>
					<option value="75">75</option>
					<option value="100">100</option>
				</select>
			</div>
			<div style="margin-left: 10px;">
				<button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
			</div>
			<span *ngIf="isLoading" class="throbber" style="margin-left: 10px;"></span>
		</div>
		<div class="col d-flex align-items-center justify-content-end mb-2">
			<div class="col d-flex justify-content-end">
				<button class="btn btn-outline-info" [routerLink]="['/', { outlets: { popup: 'properties/new' } }]" queryParamsHandling="merge">
					<i class="fa fa-asterisk fa-md"></i>
					<span style="margin-left: 5px;" jhiTranslate="ontology-manager.tab.properties.new"> New</span>
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="properties" class="table-responsive mt-3">
		<div class="custom-scroll-style adjustable-height">
			<table *ngIf="properties.length else nodata" class="table table-striped table-bordered table-curved table-editable">
				<thead class="sticky-header">
				<tr [(ascending)]="reverse" [(predicate)]="predicate" [callback]="transition.bind(this)" jhiSort>
					<th [jhiSortBy]="ColumnLabels.NAME"><span jhiTranslate="ontology-manager.property.search.columns.property-name"></span> <span class="fa fa-sort"></span></th>
					<th [jhiSortBy]="ColumnLabels.DESCRIPTION"><span jhiTranslate="ontology-manager.property.search.columns.property-description"></span> <span class="fa fa-sort"></span></th>
					<th [jhiSortBy]="ColumnLabels.CLASSES"><span jhiTranslate="ontology-manager.property.search.columns.property-classes"></span> <span class="fa fa-sort"></span></th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let item of properties; trackBy: trackId">
					<td><a [routerLink]="['/', { outlets: { popup: ['properties', item.id, 'view'] } }]">

						<truncate-span [textInput]="item?.name" [maxLength]="NAME_TEXT_LIMIT"></truncate-span>
					</a></td>
					<td>
						<truncate-span [textInput]="item?.description" [maxLength]="DESCRIPTION_TEXT_LIMIT"></truncate-span>
					</td>
					<td>
						<span *ngIf="!item?.classes ||  item?.classes.length === 0"> - </span>
						<span *ngIf="item?.classes">
							<span *ngFor="let className of item.classes; let last = last;">
								<truncate-span [textInput]="className"></truncate-span>
								{{ last ? '' : '' }}
							</span>
						</span>
					</td>
				</tbody>
			</table>
			<ng-template #nodata>
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr>
						<th></th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td jhiTranslate="no.data"></td>
					</tr>
					</tbody>
				</table>
			</ng-template>
		</div>
	</div>
	<div *ngIf="properties && properties.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="d-inline-block ms-3">
						<label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
						<input id="goToPage" type="number" class="form-control d-inline-block w-auto"
							   [min]="1" [max]="totalItems"
							   [(ngModel)]="page"
							   (change)="loadPage(page); $event.preventDefault()"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
